import React from 'react'

import styled from 'styled-components'

import SkillsTestSubmissionReminder from './SkillsTestSubmissionReminder'
import RemoteFitnessAssessmentReminder from './RemoteFitnessAssessmentReminder'

const EmailParameterForm = ({
  emailReminders,
  emailParameters,
  onChange,
  fieldErrors,
}) => {
  const checkedReminders = emailReminders
    .filter((e) => e.checked)
    .map((e) => e.title)

  const getCreatableSelectValues = (name) =>
    emailParameters[name]?.map((e) => ({ label: e, value: e }))

  return (
    <StyledEmailParemeterForm>
      {checkedReminders.includes('Remote Fitness Assessment Reminder') && (
        <RemoteFitnessAssessmentReminder
          referralEmail={emailParameters?.remote_fitness_referral_email}
          onChange={onChange}
          fieldErrors={fieldErrors}
        />
      )}

      {checkedReminders.includes('Skills Test Submission Reminder') && (
        <SkillsTestSubmissionReminder
          referralEmail={emailParameters?.skills_test_referral_email}
          subject={emailParameters?.test_subject}
          testsUrl={getCreatableSelectValues('tests_url')}
          onChange={onChange}
          fieldErrors={fieldErrors}
        />
      )}
    </StyledEmailParemeterForm>
  )
}

const StyledEmailParemeterForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`

export default EmailParameterForm
